export const rentSaleProducts = [
    {
        id: 1,
        title: 'Property',
        data:[
    {
        "ItemId": 2,
        "property_type": "property",
        "property_id": "4",
        "pcategory_id": "2",
        "package_id": "0",
        "client_id": "0",
        "name": "Villa",
        "ptype_id": "Sale",
        "no_of_room": "5",
        "carpet_area": "5000",
        "bathroom": "2",
        "car_parking": "3",
        "remarks": "Very good furnished, and wel decorated",
        "address": "Kolkata",
        "area": "ripon street",
        "district": "Kolkata",
        "police_station": "park street",
        "landmark": "Tinkonia Park",
        "pin_no": "700016",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "62c808fb19d2c_istockphoto-147205632-612x612.jpg",
        "pic2": "",
        "pic3": "",
        "pic6": "",
        "pic7": "",
        "pic8": "",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Aadhaar_Card",
        "pic4": "",
        "pic5": "62c808fb1e536_1126753.jpg",
        "add_date": "2022-03-27",
        "status": "Approved",
        "PROPID": "TKPN1002",
        "featured": "Y",
        "amount": "80,00,000"
    },
    {
        "ItemId": 3,
        "property_type": "property",
        "property_id": "5",
        "pcategory_id": "2",
        "package_id": "1",
        "client_id": "1",
        "name": "KOLAPUR SOCIETY",
        "ptype_id": "Rent",
        "no_of_room": "3",
        "carpet_area": "2022",
        "bathroom": "2",
        "car_parking": "Outside_Yes",
        "remarks": "Aewsome",
        "address": "Santoshpur, Green Avenue",
        "area": "Green Avenue",
        "district": "Kolkata",
        "police_station": "Kolkata",
        "landmark": "Ration Dealer",
        "pin_no": "700075",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "62c82022ee4c7_Kolahpur Society.webp",
        "pic2": "62c82023a59f9_Kolahpur Society.webp",
        "pic3": "62c82023a5aee_Kolahpur Society.webp",
        "pic6": "",
        "pic7": "",
        "pic8": "",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Aadhaar_Card",
        "pic4": "62c820cb16513_Chinese_Service_E-Passport_Passport_Personal_Info_Page.jpg",
        "pic5": "62c82023a5cbd_bhagwat-banquets-kankarbagh-patna-banquet-halls-76vx3m8wyh 2",
        "add_date": "2022-03-29",
        "status": "Approved",
        "PROPID": "TKPN1003",
        "featured": "Y",
        "amount": "17000"
    },
    {
        "ItemId": 4,
        "property_type": "property",
        "property_id": "6",
        "pcategory_id": "4",
        "package_id": "1",
        "client_id": "7",
        "name": "Dharma-PG for Professional",
        "ptype_id": "Rent",
        "no_of_room": "5",
        "carpet_area": "2000",
        "bathroom": "Yes",
        "car_parking": "Inside_Yes",
        "remarks": "123",
        "address": "kol",
        "area": "kol",
        "district": "kol",
        "police_station": "kol",
        "landmark": "kol",
        "pin_no": "700075",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "62c81ec1b3f0b_main-qimg-42f766f5280208a5b952849352ed800c-lq.jpg",
        "pic2": "62c81ec1b400e_main-qimg-dda60e04fb3b99cb0725d40a518c3180-lq.jpg",
        "pic3": "62c81ec1b55a4_GirlsCoHonearGalleria.jpg",
        "pic6": "",
        "pic7": "",
        "pic8": "",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Voter_Card",
        "pic4": "62c81f42ef391_o4bf5h8z6cxtgnb6hvxj.jpg",
        "pic5": "62563d25b9fd4_bg.jpg",
        "add_date": "2022-04-13",
        "status": "Approved",
        "PROPID": "TKPN1004",
        "featured": "Y",
        "amount": "8000"
    },
    {
        "ItemId": 5,
        "property_type": "property",
        "property_id": "7",
        "pcategory_id": "1",
        "package_id": "3",
        "client_id": "13",
        "name": "RAJARHAT NEWTOEN",
        "ptype_id": "Rent",
        "no_of_room": "10",
        "carpet_area": "2000",
        "bathroom": "Yes",
        "car_parking": "Inside_Yes",
        "remarks": "Aewsome",
        "address": "Kolkata",
        "area": "Koklara",
        "district": "Kolkata",
        "police_station": "Newtown",
        "landmark": "Rajarhat",
        "pin_no": "700075",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "62597cb5349b7_p4.jpg",
        "pic2": "62597cb532dca_p2.jpg",
        "pic3": "62597cb534570_p3.jpg",
        "pic6": "",
        "pic7": "",
        "pic8": "",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Voter_Card",
        "pic4": "629c7e7f937d7_Flat-1.jpg",
        "pic5": "62597cb534f86_0a5e391767210bffa954be79a2a17dd5.jpg",
        "add_date": "2022-04-15",
        "status": "Approved",
        "PROPID": "TKPN1000",
        "featured": "Y",
        "amount": "12000"
    },
    {
        "ItemId": 6,
        "property_type": "property",
        "property_id": "8",
        "pcategory_id": "146",
        "package_id": "1",
        "client_id": "15",
        "name": "Gour Marriage Hall",
        "ptype_id": "Rent",
        "no_of_room": "15",
        "carpet_area": "2000",
        "bathroom": "Yes",
        "car_parking": "Inside_Yes",
        "remarks": "Test",
        "address": "Coochbehar",
        "area": "25",
        "district": "cobcob",
        "police_station": "cob",
        "landmark": "cob",
        "pin_no": "700075",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "62c81c68664d0_bhagwat-banquets-kankarbagh-patna-banquet-halls-76vx3m8wyh.webp",
        "pic2": "62c81c686e447_bhagwat-banquets-kankarbagh-patna-banquet-halls-76vx3m8wyh 2",
        "pic3": "62c81d7860157_bhagwat-banquets-kankarbagh-patna-banquet-halls-76vx3m8wyh.webp",
        "pic6": "",
        "pic7": "",
        "pic8": "",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Passport",
        "pic4": "62c81d7860283_bhagwat-banquets-kankarbagh-patna-banquet-halls-76vx3m8wyh 2",
        "pic5": "625cf2840560a_banner5.jpg",
        "add_date": "2022-04-18",
        "status": "Approved",
        "PROPID": "TKPN1005",
        "featured": "Y",
        "amount": "15000"
    },
    {
        "ItemId": 7,
        "property_type": "property",
        "property_id": "9",
        "pcategory_id": "2",
        "package_id": null,
        "client_id": "0",
        "name": "DTDC Flat at Joka",
        "ptype_id": "Rent",
        "no_of_room": "2",
        "carpet_area": "850",
        "bathroom": "1",
        "car_parking": "1",
        "remarks": "A good Home with Well furnished, ready for Rent without furniture",
        "address": "Joka",
        "area": "Nr Vivekanand School",
        "district": "Kolkata",
        "police_station": "Joka",
        "landmark": "Nr Vivekanand School",
        "pin_no": "700104",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "62b1828e337cb_DTDC Flat-1.jpg",
        "pic2": "62d2bfc06a461_DTDC Flat-4.jpg",
        "pic3": "62d2bfc07602b_DTDC Flat-8.jpg",
        "pic6": "62d2bfc076123_DTDC Flat-4.jpg",
        "pic7": "62d2bfc077d87_DTDC Flat-2.jpg",
        "pic8": "62d2bfc08aa9f_DTDC Flat-5.jpg",
        "pic9": "62d2bfc08abd3_DTDC Flat-7.jpg",
        "pic10": "62d2bfc08ac8a_DTDC Flat-3.jpg",
        "pic11": "62d2bfc097e0a_DTDC Flat-6.jpg",
        "document": "Voter_Card",
        "pic4": "62c821718f8ce_Voter Card sample.jpg",
        "pic5": "62b1828e34d4b_Celling Fan",
        "add_date": "2022-06-21",
        "status": "Approved",
        "PROPID": null,
        "featured": "Y",
        "amount": "10000"
    },
    {
        "ItemId": 8,
        "property_type": "property",
        "property_id": "10",
        "pcategory_id": "18",
        "package_id": null,
        "client_id": "0",
        "name": "Kohinoor Bungalow",
        "ptype_id": "Sale",
        "no_of_room": "4",
        "carpet_area": "1000",
        "bathroom": "3",
        "car_parking": "2",
        "remarks": "Very good Bungalow with Nice and comfortable",
        "address": "Kalyani, Central Park",
        "area": "Kalyani",
        "district": "Nadia",
        "police_station": "Kalyani",
        "landmark": "Chittaranjan Park",
        "pin_no": "741235",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "62b350875b35f_CHIABARI-LAWN-AND-BUNGALOW.jpg",
        "pic2": "62b3508760d59_CHIABARI-LAWN-AND-BUNGALOW.jpg",
        "pic3": "62b350876121d_CHIABARI-LAWN-AND-BUNGALOW.jpg",
        "pic6": "62d0ef1ec6569_hall.jpg",
        "pic7": "",
        "pic8": "",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Voter_Card",
        "pic4": "62b35087617df_CHIABARI-LAWN-AND-BUNGALOW.jpg",
        "pic5": "62b3508761cad_CHIABARI-LAWN-AND-BUNGALOW.jpg",
        "add_date": "2022-06-22",
        "status": "Approved",
        "PROPID": null,
        "featured": "Y",
        "amount": "15000000"
    },
    {
        "ItemId": 9,
        "property_type": "property",
        "property_id": "11",
        "pcategory_id": "2",
        "package_id": null,
        "client_id": "0",
        "name": "Jyuti Apartment",
        "ptype_id": "Rent",
        "no_of_room": "3",
        "carpet_area": "1000",
        "bathroom": "2",
        "car_parking": "1",
        "remarks": "Well furnished, ready for Rent without furniture",
        "address": "Kalyani, Central Park",
        "area": "Nr Vivekanand School",
        "district": "Nadia",
        "police_station": "Kalyani",
        "landmark": "Chittaranjan Park",
        "pin_no": "741235",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "62f3b376ed706_Untitled.png",
        "pic2": "",
        "pic3": "",
        "pic6": "",
        "pic7": "",
        "pic8": "",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Voter_Card",
        "pic4": "",
        "pic5": "",
        "add_date": "2022-08-10",
        "status": "Suspend",
        "PROPID": null,
        "featured": "Y",
        "amount": "17500"
    },
    {
        "ItemId": 10,
        "property_type": "property",
        "property_id": "12",
        "pcategory_id": "2",
        "package_id": null,
        "client_id": "0",
        "name": "Dream Home",
        "ptype_id": "Rent",
        "no_of_room": "2",
        "carpet_area": "850",
        "bathroom": "1",
        "car_parking": "1",
        "remarks": "Well furnished, ready for Rent with furniture",
        "address": "B-1/312",
        "area": "B-Block",
        "district": "Nadia",
        "police_station": "Kalyani",
        "landmark": "Chittaranjan Park",
        "pin_no": "741235",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "641a043ae0b83_WhatsApp Image 2023-02-16 at 00.02.13 (1).jpeg",
        "pic2": "63ed281a3d7be_WhatsApp Image 2023-02-16 at 00.02.14 (1).jpeg",
        "pic3": "63ed281a3d902_WhatsApp Image 2023-02-16 at 00.02.11.jpeg",
        "pic6": "63ed281a3dca1_WhatsApp Image 2023-02-16 at 00.02.13.jpeg",
        "pic7": "63ed281a3de3f_WhatsApp Image 2023-02-16 at 00.02.14.jpeg",
        "pic8": "63ed281a3df6b_WhatsApp Image 2023-02-16 at 00.02.16.jpeg",
        "pic9": "63ed281a3e0a0_WhatsApp Image 2023-02-16 at 00.02.16.jpeg",
        "pic10": "",
        "pic11": "",
        "document": "Voter_Card",
        "pic4": "63ed281a3da68_Pan Card Self.jpg",
        "pic5": "63ed281a3db74_Repeat Customer.jpg",
        "add_date": "2023-02-16",
        "status": "Suspend",
        "PROPID": null,
        "featured": "Y",
        "amount": "12000"
    },
    {
        "ItemId": 12,
        "property_type": "property",
        "property_id": "14",
        "pcategory_id": "2",
        "package_id": null,
        "client_id": "0",
        "name": "Alter Testing",
        "ptype_id": "Rent",
        "no_of_room": "3",
        "carpet_area": "1099",
        "bathroom": "2",
        "car_parking": "1",
        "remarks": "None",
        "address": "Test address",
        "area": "Test area",
        "district": "Test district",
        "police_station": "Test",
        "landmark": "Test",
        "pin_no": "456678",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "64194bee2430f_Bedroom-1.jpg",
        "pic2": "64194c10d6a95_Bedroom-2.jpg",
        "pic3": "64194de73c7d0_Bedroom-3.jpg",
        "pic6": "641964408c529_Hall Room.jpg",
        "pic7": "",
        "pic8": "",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Aadhaar_Card",
        "pic4": "",
        "pic5": "",
        "add_date": "2023-03-21",
        "status": "Suspend",
        "PROPID": null,
        "featured": "Y",
        "amount": "12000"
    },
    {
        "ItemId": 13,
        "property_type": "property",
        "property_id": "15",
        "pcategory_id": "2",
        "package_id": null,
        "client_id": "0",
        "name": "New Prop",
        "ptype_id": "Rent",
        "no_of_room": "2",
        "carpet_area": "1209",
        "bathroom": "Yes",
        "car_parking": "Yes",
        "remarks": "No",
        "address": "New address",
        "area": "Wab",
        "district": "WB",
        "police_station": "WB",
        "landmark": "WB",
        "pin_no": "765876",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "6419d8047cb01_Screenshot_2023-03-21-21-35-08-48_c0d35d5c8ea536686f7fb1c9f2f8f274.jpg",
        "pic2": "",
        "pic3": "",
        "pic6": "6419d8047ce73_1679415271649135382255680621233.jpg",
        "pic7": "",
        "pic8": "",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Driving_License",
        "pic4": "",
        "pic5": "6517f372b34f8_ddd.php",
        "add_date": "2023-03-21",
        "status": "Suspend",
        "PROPID": null,
        "featured": "Y",
        "amount": "2000"
    },
    {
        "ItemId": 14,
        "property_type": "property",
        "property_id": "16",
        "pcategory_id": "1",
        "package_id": null,
        "client_id": "0",
        "name": "Basic Home 01",
        "ptype_id": "Rent",
        "no_of_room": "3",
        "carpet_area": "1200",
        "bathroom": "Yes",
        "car_parking": "Yes",
        "remarks": "No",
        "address": "Basic Home 01 address",
        "area": "Basic Home 01 area",
        "district": "Basic Home 01 district",
        "police_station": "Basic Home 01 PS",
        "landmark": "Basic Home 01 LM",
        "pin_no": "765894",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "6419db283e6e9_Bedroom - 2.jpg",
        "pic2": "6419db283f486_Bedroom - 1.jpg",
        "pic3": "6419db2840c5c_Bedroom -3.jpg",
        "pic6": "6419db2842d67_Hall Room.jpg",
        "pic7": "6419db284517e_Kitchen.jpg",
        "pic8": "",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Aadhaar_Card",
        "pic4": "",
        "pic5": "",
        "add_date": "2023-03-21",
        "status": "Suspend",
        "PROPID": null,
        "featured": "Y",
        "amount": "5000"
    },
    {
        "ItemId": 15,
        "property_type": "property",
        "property_id": "17",
        "pcategory_id": "2",
        "package_id": null,
        "client_id": "0",
        "name": "Bagchhi Flat",
        "ptype_id": "Rent",
        "no_of_room": "3",
        "carpet_area": "1099",
        "bathroom": "2",
        "car_parking": "1",
        "remarks": "A good house, At 4th Floor with very nice sceneries.",
        "address": "B-1/143",
        "area": "B-Block",
        "district": "Nadia",
        "police_station": "Kalyani",
        "landmark": "Nr 2no Market",
        "pin_no": "741235",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "641a000b28ca5_Bedroom - 1.jpg",
        "pic2": "641a000b2aba1_Bedroom - 2.jpg",
        "pic3": "641a0098183b2_Bedroom -3.jpg",
        "pic6": "641a000b2b939_Hall Room.jpg",
        "pic7": "641a000b2d68f_Kitchen.jpg",
        "pic8": "641a000b2f439_Bathroom -1.jpg",
        "pic9": "641a000b3023b_Bathroom-2.jpg",
        "pic10": "641a000b3100e_Balconi.jpg",
        "pic11": "",
        "document": "Voter_Card",
        "pic4": "",
        "pic5": "",
        "add_date": "2023-03-22",
        "status": "Approved",
        "PROPID": null,
        "featured": "Y",
        "amount": "11000"
    },
    {
        "ItemId": 16,
        "property_type": "property",
        "property_id": "18",
        "pcategory_id": "2",
        "package_id": null,
        "client_id": "0",
        "name": "Dream Home",
        "ptype_id": "Rent",
        "no_of_room": "3",
        "carpet_area": "1000",
        "bathroom": "1",
        "car_parking": "1",
        "remarks": "Very Good Home",
        "address": "B-1/312",
        "area": "B-Block",
        "district": "Nadia",
        "police_station": "Kalyani",
        "landmark": "Nr Chittaranjan Park",
        "pin_no": "741235",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "641a05cedd872_Cover.png",
        "pic2": "641a05cede163_WhatsApp Image 2023-02-16 at 00.02.14 (1).jpeg",
        "pic3": "641a05cede847_WhatsApp Image 2023-02-16 at 00.02.13 (1).jpeg",
        "pic6": "641a05cedeae2_WhatsApp Image 2023-02-16 at 00.02.11.jpeg",
        "pic7": "641a05cedf0cd_WhatsApp Image 2023-02-16 at 00.02.14.jpeg",
        "pic8": "641a05cedf3df_WhatsApp Image 2023-02-16 at 00.02.16.jpeg",
        "pic9": "",
        "pic10": "",
        "pic11": "",
        "document": "Aadhaar_Card",
        "pic4": "",
        "pic5": "",
        "add_date": "2023-03-22",
        "status": "Approved",
        "PROPID": null,
        "featured": "Y",
        "amount": "15000"
    },
    {
        "ItemId": 17,
        "property_type": "property",
        "property_id": "19",
        "pcategory_id": "18",
        "package_id": null,
        "client_id": "0",
        "name": "Chandan",
        "ptype_id": "Rent",
        "no_of_room": "2",
        "carpet_area": "1000",
        "bathroom": "1",
        "car_parking": "1",
        "remarks": "Very Nice and comfortable Home, At Ground Floor very convenient",
        "address": "B4/429",
        "area": "B-Block",
        "district": "Nadia",
        "police_station": "Kalyani",
        "landmark": "Near Buddha Park",
        "pin_no": "741235",
        "cno1": "",
        "cno2": "",
        "email": "",
        "pic1": "658c729948b40_mah.php",
        "pic2": "64312a13cfcab_Bedroom-1.jpeg",
        "pic3": "64312a13cff58_WhatsApp Image 2023-04-08 at 13.43.52.jpeg",
        "pic6": "64312a13d05a1_HallRoom.jpeg",
        "pic7": "64312a13d07f9_Kitchen.jpeg",
        "pic8": "64312a13d0a11_Toilet.jpeg",
        "pic9": "",
        "pic10": "64312a13d0b78_Branda.jpeg",
        "pic11": "",
        "document": "Voter_Card",
        "pic4": "64312a13d010d_WhatsApp Image 2023-04-08 at 13.43.52 (2).jpeg",
        "pic5": "64312a13d0347_WhatsApp Image 2023-04-08 at 13.43.52.jpeg",
        "add_date": "2023-04-08",
        "status": "Approved",
        "PROPID": null,
        "featured": "Y",
        "amount": "10000"
    }
        ]
    },
    {
        id: 2,
        title: 'Furniture',
        data: [
          {
              "ItemId": 18,
              "property_type": "furniture",
              "furniture_id": "1",
              "package_id": "3",
              "client_id": "13",
              "name": "Box Bed",
              "ptype_id": "Sale",
              "pcategory_id": "6",
              "details": "7ft X 7ft DDD",
              "address": "cob",
              "area": "kol",
              "district": "kol",
              "police_station": "Newtown",
              "landmark": "Rajarhat",
              "pin_no": "700075",
              "cno1": "",
              "cno2": "",
              "email": null,
              "pic1": "629e4c48d35d3_bOX BED.jpg",
              "pic2": "",
              "pic3": "",
              "pic4": "",
              "pic5": "",
              "document": "",
              "add_date": "2022-05-20",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "40000",
              "brand_id": "41",
              "model_id": "7"
          },
          {
              "ItemId": 19,
              "property_type": "furniture",
              "furniture_id": "2",
              "package_id": null,
              "client_id": null,
              "name": "Dinning Table",
              "ptype_id": "Rent",
              "pcategory_id": "0",
              "details": "Dinning table",
              "address": "cob",
              "area": "kol",
              "district": "Kolkata",
              "police_station": "kol",
              "landmark": "Rajarhat",
              "pin_no": "700075",
              "cno1": "",
              "cno2": "",
              "email": null,
              "pic1": "629c7c4a8ef29_Dinning Table.jpg",
              "pic2": "",
              "pic3": "",
              "pic4": "",
              "pic5": "6286915a9582e_landlord.png",
              "document": "Voter_Card",
              "add_date": "2022-05-20",
              "status": "Suspend",
              "featured": "Y",
              "PROPID": null,
              "amount": "0",
              "brand_id": "0",
              "model_id": "0"
          },
          {
              "ItemId": 20,
              "property_type": "furniture",
              "furniture_id": "3",
              "package_id": "1",
              "client_id": "13",
              "name": "TEST FUR",
              "ptype_id": "Sale",
              "pcategory_id": null,
              "details": "Test",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "628b03832dcb8_c1.jpg",
              "pic2": "628b05727eb17_bg.jpg",
              "pic3": "628b05727ec3c_bg5.jpg",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-05-23",
              "status": "Pending",
              "featured": "N",
              "PROPID": "TKPN1002",
              "amount": "0",
              "brand_id": "0",
              "model_id": "0"
          },
          {
              "ItemId": 21,
              "property_type": "furniture",
              "furniture_id": "5",
              "package_id": null,
              "client_id": null,
              "name": "Wooden old Bed",
              "ptype_id": "Sale",
              "pcategory_id": "6",
              "details": "Type- Wooden\r\nConvertible- No",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "629c78a0129de_Bed.jpg",
              "pic2": "",
              "pic3": "",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-05-23",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "3000",
              "brand_id": "31",
              "model_id": "4"
          },
          {
              "ItemId": 22,
              "property_type": "furniture",
              "furniture_id": "6",
              "package_id": null,
              "client_id": null,
              "name": "Floral Glass Dinning Table",
              "ptype_id": "Sale",
              "pcategory_id": "6",
              "details": "Floral Glass Rectangular Steel 4 sheeter  ",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "629e412fa53a0_Dinning Table.jpg",
              "pic2": "",
              "pic3": "",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-06-05",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "6000",
              "brand_id": "31",
              "model_id": "7"
          },
          {
              "ItemId": 23,
              "property_type": "furniture",
              "furniture_id": "7",
              "package_id": null,
              "client_id": null,
              "name": "Wooden Dinning Table",
              "ptype_id": "Sale",
              "pcategory_id": "6",
              "details": "Nice Look Dinning Table 06 Seaters",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "62ae2602c954c_wooden-dining-table-set-500x500.jpg",
              "pic2": "",
              "pic3": "",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-06-06",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "15000",
              "brand_id": "4",
              "model_id": "5"
          },
          {
              "ItemId": 24,
              "property_type": "furniture",
              "furniture_id": "8",
              "package_id": null,
              "client_id": null,
              "name": "Designer Sofa fabric made",
              "ptype_id": "Sale",
              "pcategory_id": "6",
              "details": "Sofa 3seater with full set in  Good Condition",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "62b4a0a328791_Sofa 3seater.jpg",
              "pic2": "",
              "pic3": "",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-06-07",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "35000",
              "brand_id": "31",
              "model_id": "6"
          },
          {
              "ItemId": 25,
              "property_type": "furniture",
              "furniture_id": "9",
              "package_id": "3",
              "client_id": "13",
              "name": "Sofa ",
              "ptype_id": "Sale",
              "pcategory_id": "6",
              "details": "3seater",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "629e4b3fb1b89_Sofa 3seater.jpg",
              "pic2": "629e4b6b360fb_Sofa 3seater.jpg",
              "pic3": "629e4b6b37a6f_Sofa 3seater.jpg",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-06-07",
              "status": "Approved",
              "featured": "N",
              "PROPID": "TKPN1007",
              "amount": "35000",
              "brand_id": "31",
              "model_id": "4"
          },
          {
              "ItemId": 26,
              "property_type": "furniture",
              "furniture_id": "10",
              "package_id": null,
              "client_id": null,
              "name": "Sofa Cum Bed",
              "ptype_id": "Rent",
              "pcategory_id": "6",
              "details": "Rs-500/- per month, Looks New in Good Condition",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "62b183b1619e2_Sofa Cum Bed-1.jpg",
              "pic2": "62b183b161fe8_Sofa Cum Bed-2.jpg",
              "pic3": "",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-06-21",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "500",
              "brand_id": "31",
              "model_id": "3"
          },
          {
              "ItemId": 27,
              "property_type": "furniture",
              "furniture_id": "11",
              "package_id": null,
              "client_id": null,
              "name": "Dinning Table Wooden",
              "ptype_id": "Sale",
              "pcategory_id": "6",
              "details": "Dinning Table Wooden with blackish glass",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "62b1844694465_Dining table Wooden.jpg",
              "pic2": "",
              "pic3": "",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-06-21",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "12000",
              "brand_id": "31",
              "model_id": "5"
          }
        ]
    },
    {
        id: 3,
        title: 'Vehicle',
        data: [
          {
              "ItemId": 28,
              "property_type": "vehicle",
              "vehicle_id": "1",
              "package_id": null,
              "client_id": null,
              "name": "TVs XL 100 Bike",
              "ptype_id": "Sale",
              "pcategory_id": "12",
              "details": "Mileage (Overall)80 kmpl, Displacement 99.7 cc Engine Type4 Stroke Single Cylinder No. of Cylinders1Max Power4.4 PS @ 6000 rpmMax Torque6.5 Nm @ 3500 rpm Front Brake Drum Rear Brake Drum Fuel Capacity4 LBody Type Moped Bikes\r\nTVS XL100 Features\r\nBraking Type Synchronized Braking System Charging Point Yes Speedometer Analogue Odometer Analogue Fuel gauge Yes",
              "address": "cob",
              "area": "Koklara",
              "district": "Kolkata",
              "police_station": "Newtown",
              "landmark": "Rajarhat",
              "pin_no": "700075",
              "cno1": "",
              "cno2": "",
              "email": null,
              "pic1": "629e4dae88c08_Byke-2.jpg",
              "pic2": "",
              "pic3": "",
              "pic4": "",
              "pic5": "",
              "document": "",
              "add_date": "2022-05-20",
              "status": "Approved",
              "featured": "Y",
              "PROPID": "",
              "amount": "40000",
              "brand_id": "60",
              "model_id": "BS-6 Heavy Duty"
          },
          {
              "ItemId": 29,
              "property_type": "vehicle",
              "vehicle_id": "2",
              "package_id": null,
              "client_id": null,
              "name": "Maruty 800",
              "ptype_id": "Sale",
              "pcategory_id": "7",
              "details": "in good Condition",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "62af0877b510f_Maruty 800.jpg",
              "pic2": "",
              "pic3": "",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-06-19",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "25000",
              "brand_id": "6",
              "model_id": "800"
          },
          {
              "ItemId": 30,
              "property_type": "vehicle",
              "vehicle_id": "3",
              "package_id": null,
              "client_id": null,
              "name": "Mini Truck-Chhota Haathi",
              "ptype_id": "Rent",
              "pcategory_id": "20",
              "details": "According to Distance rent Amount will decide, Condition is good needy people can contact",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "62af0c67a999f_Chota Haathi on Rent.jpg",
              "pic2": "",
              "pic3": "",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-06-19",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "1000",
              "brand_id": "5",
              "model_id": "TaTa Ace"
          },
          {
              "ItemId": 31,
              "property_type": "vehicle",
              "vehicle_id": "4",
              "package_id": null,
              "client_id": null,
              "name": "TaTa Truck",
              "ptype_id": "Rent",
              "pcategory_id": "24",
              "details": "TaTa Truck available for Rent, According to Distance rent Amount will decide, Condition is good needy people can contact",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "62b36afc1ef23_Truck-gvw-5400-kg.jpg",
              "pic2": "62b36afc1f3e2_Truck-gvw-5400-kg.jpg",
              "pic3": "62b36afc1f824_Truck-gvw-5400-kg.jpg",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-06-23",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "1000",
              "brand_id": "5",
              "model_id": "Eicher"
          },
          {
              "ItemId": 32,
              "property_type": "vehicle",
              "vehicle_id": "5",
              "package_id": null,
              "client_id": null,
              "name": "Volvo bus",
              "ptype_id": "Rent",
              "pcategory_id": "24",
              "details": "Volvo bus , Well condition hire for Wedding and Tour, According to Distance rent Amount will decide, Condition is good needy people can contact",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "62b36b45771a0_Volvo-bus-services-volvo-manali.jpg",
              "pic2": "62b36b45777a4_Volvo-bus-services-volvo-manali.jpg",
              "pic3": "62b36b4577c7f_Volvo-bus-services-volvo-manali.jpg",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2022-06-23",
              "status": "Approved",
              "featured": "Y",
              "PROPID": null,
              "amount": "2000",
              "brand_id": "5",
              "model_id": "Volvo"
          },
          {
              "ItemId": 33,
              "property_type": "vehicle",
              "vehicle_id": "7",
              "package_id": null,
              "client_id": "19",
              "name": "Vehicle 2",
              "ptype_id": "Rent",
              "pcategory_id": null,
              "details": "Sedan",
              "address": null,
              "area": null,
              "district": null,
              "police_station": null,
              "landmark": null,
              "pin_no": null,
              "cno1": null,
              "cno2": null,
              "email": null,
              "pic1": "63ed28841cf85_R.jfif",
              "pic2": "63ed28841d274_OIP.jfif",
              "pic3": "",
              "pic4": null,
              "pic5": null,
              "document": null,
              "add_date": "2023-02-16",
              "status": "Pending",
              "featured": "N",
              "PROPID": "TKPN1006",
              "amount": null,
              "brand_id": null,
              "model_id": null
          }
        ]
    },
    {
        id: 4,
        title: 'Electronic Appliance',
        data: [
            {
                "ItemId": 34,
                "property_type": "electronic appliance",
                "electrical_id": "1",
                "package_id": null,
                "client_id": null,
                "name": "Refrigerator",
                "ptype_id": "Rent",
                "pcategory_id": "10",
                "details": "180 L Dark Pink Color",
                "address": "cob",
                "area": "Koklara",
                "district": "kol",
                "police_station": "kol",
                "landmark": "Rajarhat",
                "pin_no": "700075",
                "cno1": "",
                "cno2": "",
                "email": null,
                "pic1": "629e46ad38d07_Fridge.jpg",
                "pic2": "",
                "pic3": "",
                "pic4": "",
                "pic5": "",
                "document": "",
                "add_date": "2022-05-20",
                "status": "Approved",
                "featured": "Y",
                "PROPID": "",
                "amount": "17000",
                "brand_id": "42",
                "model_id": "32"
            },
            {
                "ItemId": 35,
                "property_type": "electronic appliance",
                "electrical_id": "2",
                "package_id": null,
                "client_id": null,
                "name": "220 L Ref 2008",
                "ptype_id": "Rent",
                "pcategory_id": "10",
                "details": "Test",
                "address": null,
                "area": null,
                "district": null,
                "police_station": null,
                "landmark": null,
                "pin_no": null,
                "cno1": null,
                "cno2": null,
                "email": null,
                "pic1": "62aedf50da58c_1.jpg",
                "pic2": "",
                "pic3": "",
                "pic4": null,
                "pic5": null,
                "document": null,
                "add_date": "2022-06-19",
                "status": "Approved",
                "featured": "N",
                "PROPID": null,
                "amount": "0",
                "brand_id": "0",
                "model_id": "0"
            },
            {
                "ItemId": 36,
                "property_type": "electronic appliance",
                "electrical_id": "3",
                "package_id": null,
                "client_id": null,
                "name": "Old Table Fan",
                "ptype_id": "Sale",
                "pcategory_id": "14",
                "details": "Old Model Table Fan",
                "address": null,
                "area": null,
                "district": null,
                "police_station": null,
                "landmark": null,
                "pin_no": null,
                "cno1": null,
                "cno2": null,
                "email": null,
                "pic1": "62b17aa48e484_Table Fan.jpg",
                "pic2": "",
                "pic3": "",
                "pic4": null,
                "pic5": null,
                "document": null,
                "add_date": "2022-06-21",
                "status": "Approved",
                "featured": "Y",
                "PROPID": null,
                "amount": "3500",
                "brand_id": "141",
                "model_id": "8"
            },
            {
                "ItemId": 37,
                "property_type": "electronic appliance",
                "electrical_id": "4",
                "package_id": null,
                "client_id": null,
                "name": "Celling Fan ",
                "ptype_id": "Sale",
                "pcategory_id": "15",
                "details": "Celling Fan , Blue Color Good Condition",
                "address": null,
                "area": null,
                "district": null,
                "police_station": null,
                "landmark": null,
                "pin_no": null,
                "cno1": null,
                "cno2": null,
                "email": null,
                "pic1": "62cb0c1ba135c_celling fan spiro.png",
                "pic2": "62cb0c1ba2640_havells-ceiling-fan-500x500.jpg",
                "pic3": "62cb0c1ba26b5_standard-ceiling-fan-500x500.jpg",
                "pic4": null,
                "pic5": null,
                "document": null,
                "add_date": "2022-06-21",
                "status": "Approved",
                "featured": "Y",
                "PROPID": null,
                "amount": "2500",
                "brand_id": "3",
                "model_id": "2"
            },
            {
                "ItemId": 38,
                "property_type": "electronic appliance",
                "electrical_id": "5",
                "package_id": null,
                "client_id": null,
                "name": "Electrical Kettle",
                "ptype_id": "Sale",
                "pcategory_id": "130",
                "details": "Electric Kettle with Stainless Steel Body, 1.8 litre, used for boiling Water, making tea and coffee, instant noodles, soup etc. 1500 Watt Multi Cooker Electric Kettle  (2 L, Multicolor)",
                "address": null,
                "area": null,
                "district": null,
                "police_station": null,
                "landmark": null,
                "pin_no": null,
                "cno1": null,
                "cno2": null,
                "email": null,
                "pic1": "62c825174582d_Electrical Kettle.jpg",
                "pic2": "62c8251746f6b_Electrical Kettle.jpg",
                "pic3": "62c8251746fca_Electrical Kettle.jpg",
                "pic4": null,
                "pic5": null,
                "document": null,
                "add_date": "2022-07-08",
                "status": "Approved",
                "featured": "Y",
                "PROPID": null,
                "amount": "1000",
                "brand_id": "42",
                "model_id": "Sam-El-K25"
            },
            {
                "ItemId": 39,
                "property_type": "electronic appliance",
                "electrical_id": "6",
                "package_id": null,
                "client_id": null,
                "name": "Tower AC",
                "ptype_id": "Rent",
                "pcategory_id": "147",
                "details": "In Good condition available for rent",
                "address": null,
                "area": null,
                "district": null,
                "police_station": null,
                "landmark": null,
                "pin_no": null,
                "cno1": null,
                "cno2": null,
                "email": null,
                "pic1": "62cb09ec5905c_tower-ac-on-rent-500x500.jpg",
                "pic2": "62cb09ec69a9e_tower-ac-rental-service-500x500n.jpg",
                "pic3": "",
                "pic4": null,
                "pic5": null,
                "document": null,
                "add_date": "2022-07-10",
                "status": "Approved",
                "featured": "Y",
                "PROPID": null,
                "amount": "3000",
                "brand_id": "42",
                "model_id": "Sam-El-TA258"
            },
            {
                "ItemId": 40,
                "property_type": "electronic appliance",
                "electrical_id": "7",
                "package_id": null,
                "client_id": null,
                "name": "Floor Cooler",
                "ptype_id": "Rent",
                "pcategory_id": "148",
                "details": "Available for Rent in Good Condition",
                "address": null,
                "area": null,
                "district": null,
                "police_station": null,
                "landmark": null,
                "pin_no": null,
                "cno1": null,
                "cno2": null,
                "email": null,
                "pic1": "62cb0b2cb29d0_Air-Cooler-Floor-Standing-Room-Air-Cooler-for-Sale.jpg",
                "pic2": "62cb0b2cb4ac0_Air-Cooler-Floor-Standing.jpg",
                "pic3": "62cb0b2cb4b05_owsm-simba-1000x1000 cooler.webp",
                "pic4": null,
                "pic5": null,
                "document": null,
                "add_date": "2022-07-10",
                "status": "Approved",
                "featured": "Y",
                "PROPID": null,
                "amount": "1500",
                "brand_id": "46",
                "model_id": "HC-648khn"
            },
            {
                "ItemId": 41,
                "property_type": "electronic appliance",
                "electronics_id": "8",
                "package_id": null,
                "client_id": null,
                "name": "Samsung TV",
                "ptype_id": "Sale",
                "pcategory_id": "9",
                "details": "",
                "address": "dfg",
                "area": "kol",
                "district": "kol",
                "police_station": "Newtown",
                "landmark": "kol",
                "pin_no": "700075",
                "cno1": "",
                "cno2": "",
                "email": null,
                "pic1": "629dc6bd0c443_SamsungTV.jpg",
                "pic2": "",
                "pic3": "",
                "pic4": "",
                "pic5": "",
                "document": "",
                "add_date": "2022-05-20",
                "status": "Approved",
                "featured": "Y",
                "PROPID": "",
                "amount": "20000",
                "brand_id": "1",
                "model_id": "UA43AUE70AKLXL"
            },
            {
                "ItemId": 42,
                "property_type": "electronic appliance",
                "electronics_id": "9",
                "package_id": null,
                "client_id": null,
                "name": "Laptop",
                "ptype_id": "Sale",
                "pcategory_id": "17",
                "details": "",
                "address": null,
                "area": null,
                "district": null,
                "police_station": null,
                "landmark": null,
                "pin_no": null,
                "cno1": null,
                "cno2": null,
                "email": null,
                "pic1": "62af0aad4223f_Accer Laptop.jpg",
                "pic2": "",
                "pic3": "",
                "pic4": null,
                "pic5": null,
                "document": null,
                "add_date": "2022-06-19",
                "status": "Approved",
                "featured": "Y",
                "PROPID": null,
                "amount": "18000",
                "brand_id": "55",
                "model_id": "Swift-3"
            },
            {
                "ItemId": 43,
                "property_type": "electronic appliance",
                "electronics_id": "10",
                "package_id": null,
                "client_id": null,
                "name": "Home Theater ",
                "ptype_id": "Sale",
                "pcategory_id": "11",
                "details": "",
                "address": null,
                "area": null,
                "district": null,
                "police_station": null,
                "landmark": null,
                "pin_no": null,
                "cno1": null,
                "cno2": null,
                "email": null,
                "pic1": "62b17ddf52403_Home Theater.jpg",
                "pic2": "",
                "pic3": "",
                "pic4": null,
                "pic5": null,
                "document": null,
                "add_date": "2022-06-21",
                "status": "Approved",
                "featured": "Y",
                "PROPID": null,
                "amount": "1750",
                "brand_id": "113",
                "model_id": "SP-lo34"
            },
            {
                "ItemId": 44,
                "property_type": "electronic appliance",
                "electronics_id": "11",
                "package_id": null,
                "client_id": null,
                "name": "Sport Watch",
                "ptype_id": "Rent",
                "pcategory_id": "21",
                "details": "",
                "address": null,
                "area": null,
                "district": null,
                "police_station": null,
                "landmark": null,
                "pin_no": null,
                "cno1": null,
                "cno2": null,
                "email": null,
                "pic1": "62b17ec440250_Sport Watch.jpg",
                "pic2": "",
                "pic3": "",
                "pic4": null,
                "pic5": null,
                "document": null,
                "add_date": "2022-06-21",
                "status": "Approved",
                "featured": "Y",
                "PROPID": null,
                "amount": "4550",
                "brand_id": "1",
                "model_id": "Gear S3"
            },
            {
                "ItemId": 45,
                "property_type": "electronic appliance",
                "electronics_id": "12",
                "package_id": null,
                "client_id": null,
                "name": "Juicer Mixer Grinder",
                "ptype_id": "Sale",
                "pcategory_id": "27",
                "details": "",
                "address": null,
                "area": null,
                "district": null,
                "police_station": null,
                "landmark": null,
                "pin_no": null,
                "cno1": null,
                "cno2": null,
                "email": null,
                "pic1": "62b5d4f60a0ee_Bajaj Mixi.webp",
                "pic2": "62b5d4f60b3f8_Bajaj Mixi.webp",
                "pic3": "62b5d4f60ca11_Bajaj Mixi.webp",
                "pic4": null,
                "pic5": null,
                "document": null,
                "add_date": "2022-06-24",
                "status": "Approved",
                "featured": "Y",
                "PROPID": null,
                "amount": "2500",
                "brand_id": "91",
                "model_id": "7"
            }
        ]
    }
]

